import { ATS_APP_PUBLIC_NAME, ROBOTA_UA } from '@alliance/shared/constants'
import { CategoriesDataValuesEnum } from '../models/categories-data-values.enum'
import { OnboardingCategoriesEnum } from '../../../domain/models/onboarding-categories.enum'

const headings: Record<CategoriesDataValuesEnum, string> = {
  [CategoriesDataValuesEnum.connectVacancies]: 'Прив’яжіть вакансії до проєкту',
  [CategoriesDataValuesEnum.fillFields]: 'Заповніть поля вручну',
  [CategoriesDataValuesEnum.addFromDataBase]: `Додайте з бази резюме ${ATS_APP_PUBLIC_NAME}`,
  [CategoriesDataValuesEnum.importVacancies]: 'Імпортуйте вакансії в проєкти',
  [CategoriesDataValuesEnum.connectIntegration]: 'Підключіть інтеграцію',
  [CategoriesDataValuesEnum.setupRecruitment]: 'Налаштуйте етапи найму',
  [CategoriesDataValuesEnum.useBrowserExtension]: 'Використайте плагін для браузера',
  [CategoriesDataValuesEnum.uploadFromTable]: 'Завантажте з таблиці Excel',
  [CategoriesDataValuesEnum.addFromRobota]: `Перенесіть з бази резюме ${ROBOTA_UA}`,
  [CategoriesDataValuesEnum.createProjectFromVacancy]: `Cтворіть проєкт з вакансії на ${ROBOTA_UA}`,
  [CategoriesDataValuesEnum.eventsAndComments]: `Перегляньте історію подій та коментарі`,
  [CategoriesDataValuesEnum.addTags]: `Додайте власні теги до кандидата`,
  [CategoriesDataValuesEnum.createInterviews]: `Створюйте зустрічі в календарі`,
  [CategoriesDataValuesEnum.rejectionReasons]: `Позначайте власні причини відмови`,
  [CategoriesDataValuesEnum.sendResume]: `Надішліть резюме на пошту замовнику`,
  [CategoriesDataValuesEnum.externalInteraction]: `Надсилайте кандидатам запрошення або відмову`,
  [CategoriesDataValuesEnum.kanban]: `Оцініть зручність канбану`,
  [CategoriesDataValuesEnum.recruitmentTemplates]: `Зберігайте та перевикористовуйте шаблони`,
  [CategoriesDataValuesEnum.publishVacancies]: `Публікуйте вакансії всюди одночасно`,
  [CategoriesDataValuesEnum.projectStatistics]: `Відслідковуйте статистику`,
  [CategoriesDataValuesEnum.projectReport]: `Отримайте звіт по проєкту найму`,
  [CategoriesDataValuesEnum.projectStagesInfo]: `Отримайте дані по етапам проєктів`,
  [CategoriesDataValuesEnum.analyzeSources]: `Аналізуйте ефективність джерел`,
  [CategoriesDataValuesEnum.recruitersActivity]: `Відслідковуйте активність рекрутерів`,
  [CategoriesDataValuesEnum.projectClosures]: `Порівнюйте час закриття проєктів`,
  [CategoriesDataValuesEnum.addRequester]: `Додайте замовника до проєкту`,
  [CategoriesDataValuesEnum.configureUserRights]: `Розподіляйте права користувачів`
}

const categories: Record<OnboardingCategoriesEnum, string> = {
  [OnboardingCategoriesEnum.candidatesInProject]: 'Як отримати кандидатів в проєкти',
  [OnboardingCategoriesEnum.whereToStart]: 'З чого почати роботу ',
  [OnboardingCategoriesEnum.actionsWithCandidates]: 'Дії з кандидатом',
  [OnboardingCategoriesEnum.funnel]: 'Налаштування воронки найму',
  [OnboardingCategoriesEnum.statisticsAndAnalytics]: 'Статистика та аналітка',
  [OnboardingCategoriesEnum.userRights]: 'Доступ колег і замовників'
}

export default {
  headings: { ...headings },
  categories: { ...categories },
  navigation: {
    prev: 'Назад',
    next: 'Далі'
  },
  content: {
    addCandidates: 'Додайте кандидатів самостійно або завантажте резюме, і ми витягнемо інформацію з файл',
    dataBase: {
      allApplies: 'Всі відгуки, які надійшли на проєкт, автоматично додаються в ',
      helper: `базу ${ATS_APP_PUBLIC_NAME}.`,
      use: ' Використовуйте її як свій резерв або джерело, яке завжди в доступі'
    },
    plugin: {
      install: 'Встановіть ',
      extension: 'плагін для браузера',
      toAddCandidates: `, щоб легко додавати кандидатів прямо з веб-сторінок до проєктів в кабінеті ${ATS_APP_PUBLIC_NAME}`
    },
    importVacancies: `Натисніть “Імпортувати вакансії”— якщо у вас є проєкти, або використайте кнопку “Імпортувати”, якщо ви новий користувач в ${ATS_APP_PUBLIC_NAME}.`,
    connectIntegration: {
      setup: 'Налаштуйте ',
      sources: 'інтеграції з джерелами',
      toGetApplies: ', щоб автоматично отримувати відгуки в проєкти. Ви можете додати необмежену кількість акаунтів з кожною інтеграцією.'
    },
    combineActiveVacancies: `З’єднайте ваші активні вакансії на ${ROBOTA_UA}, work.ua або olx з проєктами, щоб не пропустити жодного відгуку, який надходить на джерело.`,
    whileEditing: 'В режимі редагування проєкту у вас є можливість створити власні етапи рекрутингу, які відповідають вашим процесам.',
    fillCandidateInfo: `Заповніть інформацію про кандидатів самостійно або завантажте резюме, і ${ATS_APP_PUBLIC_NAME} автоматично підставить інформацію у відповідні поля`,
    uploadFileWithCandidates: `Завантажте таблицю з кандидатами в проєкт, і ${ATS_APP_PUBLIC_NAME} швидко створить з отриманих даних список канидадатів із власною сторінкою`,
    addFromRobota: `Додавайте перспективних кандидатів з бази або вакансії ${ROBOTA_UA} напряму в проєкти або базу ${ATS_APP_PUBLIC_NAME}`,
    analyzeActions: 'Аналізуйте дії, пов’язані з кандидатом, щоб краще розуміти його прогрес і приймати більш обґрунтовані рішення',
    createPersonalTags: 'Створюйте персоналізовані мітки для швидкої категоризації кандидатів по навичкам та зручного пошуку в списках по вашим особистим тегам.',
    interviews: 'Фіксуйте зустрічі, встановлюйте нагадування та додавайте співбесіди в свій календар та календар пошукача',
    rejectionReasons: 'Додавайте необмежену кількість власних причин та слідкуйте за даними по відмовах в статистиці проєкту',
    sendResume: `Відправляйте резюме кандидата замовнику безпосередньо з ${ATS_APP_PUBLIC_NAME} для більш швидкої комунікації`,
    informCandidates: 'Інформуйте кандидатів про ваші рішення за допомогою листів, не виходячі з системи',
    organizeWork: 'Організуйте роботу з кандидатами за допомогою зручної канбан-дошки',
    setupProject: 'Налаштуйте проєкт та створіть власні етапи рекрутингу, які відповідають процесам найму вашої компанії',
    createRecruitmentTemplates: 'Створіть шаблони із персоналізованим циклом найму та використовуйте їх при роботі з майбутніми проєктами',
    publishVacancies: `Заповнюйте деталі вакансії та публікуйте її з кабінету ${ATS_APP_PUBLIC_NAME} одночасно на ${ROBOTA_UA}, work.ua та olx.`,
    statistics: 'Аналізуйте цифри по активності, воронці закриття, джерелах кандидатів та відмовах до кожного проєкту найму',
    exportProjectReport: 'Експортуйте статистику по проєкту у вигляді зручного звіту в форматі Excel',
    projectFunnelInfo: 'Використовуйте зведені дані по воронці всіх проєктів та цифри по стану кожного окремого етапу',
    sourcesInfo: `Дізнайтеся, які платформи дають найкращих кандидатів, щоб оптимізувати джерела найму`,
    recruitersActivity: 'Відстежуйте персональні показники кожного рекрутера, щоб покращити результати роботи команди',
    projectClosures: 'Аналізуйте тривалість закриття проєктів, щоб оцінювати вплив ваших рішень на швидкість найму',
    inviteRequesters: 'Запрошуйте замовників до перегляду та коментування кандидатів, та отримуйте сповіщення про нові коментарі',
    configureUserRights: 'Керуйте рівнями доступу членів команди, щоб зберегти безпеку даних та розподіл відповідальності',
    createProjectFromVacancy: `З’явилась нова вакансія? Миттєво створіть з неї проєкт в ${ATS_APP_PUBLIC_NAME}, щоб прискорити роботу над кандидатами `
  }
}
